import React, { FC } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes, redirect } from "react-router-dom";

import PageError from "./../PageError/PageError";
import { HomePage } from "../../../pages/Home/HomePage";
import { TestPage } from "../../../pages/Test/TestPage";
import { AdminPage } from "../../../pages/Admin/AdminPage";
import { UHFLoaderPage } from "../../../pages/UHFLoader/UHFLoaderPage";
import { IRapComponentProperties } from "../../Layout";
import { IUhfViewState } from "../../../pages/Contracts";

import * as LocaleUtils from "../../core/util/Locale";

import "./Shell.scss";


type RouteParams = {
    locale: string;
};

interface IShellProvidedProps extends IRapComponentProperties {
    
}

interface IShellOwnProps extends IShellProvidedProps {
}

export type IShellProps = IShellOwnProps & typeof ActionsToDispatch;

const Shell:FC<IShellProps> = (props) => {
    return (
        <BrowserRouter>
            <div id="page">
                <div id="main-content" className="main-content flex-column full-size flex-grow">
                    <Routes>
                        <Route path="/:locale/" key={"Home"} element={<HomePage/>} />
                        <Route path="/:locale/admin" key={"Admin"} element={<AdminPage/>}/>
                        <Route path="/:locale/Test/FullPage" key="UhfLoader" element={<UHFLoaderPage/>}/>
                        <Route path="/:locale/Test/Migration" key={"UHFMigrationTest"} element={<TestPage alpineTest={true}/>} />
                        <Route path="/:locale/Test" key={"UHFTest"} element={<TestPage/>} />
                        <Route path="/Test" key={"TestNoLocale"} element={<Navigate to={`/${LocaleUtils.getLocale()}/Test`} />}/>
                        <Route path="/" key="empty" element={<Navigate to={`/${LocaleUtils.getLocale()}/`}/>} />
                        <Route key="fallback" element={<PageError title="Page not found" details={`Invalid path: ${window.location.pathname}`} />} />
                    </Routes>
                </div>
            </div>
        </BrowserRouter>
    );
}

// Update component props whenever the store's state changes
function mapStateToProps(state: IUhfViewState, providedProps: IShellProvidedProps): Partial<IShellProvidedProps> {
    return {
        ...providedProps,
    };
}

// Hook up action creators to reducer
const ActionsToDispatch = {
    
};

export default connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
)(Shell);

